<template>
  <b-container class="container-rda">
    <div v-if="isLoading" class="loading-container">
      <b-spinner style="color: #b23066" label="Aguarde!"></b-spinner>
    </div>
    <div v-else>
      <b-row class="pt-5 mt-4 mb-5">
        <b-col>
          <h2 class="purple bold">Bem-vindo(a)!</h2>
        </b-col>
        <b-col class="text-right">
          <b-button
            class="normal"
            :to="{
              name: 'perfil',
            }"
            >Meus dados</b-button
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="profile-row">
            <b-col>
              <img
                v-if="currentUser.photo == null || currentUser.photo == ''"
                src="@/assets/images/default-photo.png"
                height="64"
                width="64"
                alt
              />
              <img
                v-else
                width="64"
                height="64"
                :src="`${currentUser.photo}`"
                alt
              />
              <div class="content-profile">
                <h5>{{ currentUser.name }}</h5>
                <p
                  v-if="
                    isDataReady &&
                    studentData.Classroom &&
                    studentData.Classroom.year_id
                  "
                >
                  Ciclo: {{ studentData.Cycle.name }} -
                  {{ studentData.Classroom.year_id }}º ano
                </p>
                <p v-else-if="isDataReady">
                  Ciclo: {{ studentData.Cycle.name }}
                </p>
              </div>
            </b-col>
          </div>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <router-link
                class="dash-box contents"
                :to="{
                  name: 'registrar-aprendizagem',
                  params: { id: currentUser.student_id },
                }"
              >
                <h2>Registros de Aprendizagem</h2>
              </router-link>
            </b-col>

            <b-col v-if="isRegularCycle">
              <router-link
                class="dash-box comments"
                style="background-color: #4589b2"
                :to="{
                  name: 'dashboard-tutoria-aluno-responsaveis',
                  params: {
                    id: currentUser.student_id,
                  },
                }"
              >
                <h2>Tutoria</h2>
              </router-link>
            </b-col>

            <b-col>
              <router-link
                class="dash-box comments"
                :to="{
                  name: 'faltas-e-presencas',
                  params: { student_id: currentUser.student_id },
                }"
              >
                <h2>Frequência</h2>
              </router-link>
            </b-col>

            <b-col v-if="isChildCycle">
              <router-link
                class="dash-box comments"
                style="background-color: #4589b2"
                :to="{
                  name: 'dashboard-timeline-aluno-parent',
                  params: {
                    id: currentUser.student_id,
                  },
                }"
              >
                <h2>Ed. Infantil</h2>
              </router-link>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import httpRda from "@/http-rda";

export default {
  name: "",
  components: {},

  data() {
    return {
      isLoading: true,
      studentData: null,
    };
  },

  computed: {
    currentUser() {
      return this.$store.getters["auth/getAuthData"];
    },

    isDataReady() {
      return this.studentData && this.studentData.Cycle;
    },

    cycleId() {
      return this.isDataReady ? this.studentData.Cycle.id : null;
    },

    isChildCycle() {
      return this.cycleId === 8 || this.cycleId === 6;
    },

    isRegularCycle() {
      return this.cycleId && !this.isChildCycle;
    },
  },

  methods: {
    async fetchStudentBasicData(studentId) {
      try {
        const { data } = await httpRda.get(`/students/${studentId}/basic-data`);
        this.studentData = data.student;
      } catch (error) {
        console.error("Erro ao carregar dados do estudante:", error);
        this.studentData = null;
      } finally {
        this.isLoading = false;
      }
    },

    async setUser() {
      await this.fetchStudentBasicData(this.currentUser.student_id);
    },
  },

  async created() {
    if (this.currentUser.id) {
      await this.setUser();
    } else {
      this.isLoading = false;
    }
  },

  watch: {
    async currentUser(newUser) {
      if (newUser && newUser.id) {
        this.isLoading = true;
        this.studentData = null;
        await this.setUser();
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/variables.scss";

.profile-row {
  background: $gradient3;
  border-radius: 10px;
  color: $white;
  padding: 28px 10px;
  position: relative;
  &:after {
    content: url("~@/assets/images/watermark-profile.png");
    right: 0;
    pointer-events: none;
    position: absolute;
    top: -5px;
  }
  .col {
    display: flex;
    align-items: center;
    img {
      margin-right: 40px;
      border-radius: 50%;
    }
    .content-profile {
      h5 {
        margin-bottom: 14px;
      }
      p {
        margin: 0;
      }
    }
  }
}

.dash-box {
  border-radius: 19px;
  color: $white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 120px;
  padding: 15px 10px;
  text-align: center;
  p {
    margin-bottom: 10px;
  }
  h1 {
    margin: 0;
  }
  &.contents {
    background-color: $purple;
  }
  &.scripts {
    background-color: $green1;
  }
  &.comments {
    background-color: $orange;
  }
  &:hover {
    color: $white;
  }
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  width: 100%;
}
</style>
